import { ISusuarioList, UsuarioList } from '../../types/usuario/UsuarioList';
import { MenuNeto } from '../menuneto/MenuNeto';
import { ISmenuPaiList, MenuPai, MenuPaiList } from '../menuPai/MenuPai';
import { ISnoticia, NoticiaList } from '../noticia/Noticia';

export interface MenuFilho {
  id?: string;
  label: string;
  link?: string;
  noticia?: NoticiaList;
  menuPai?: MenuPaiList;
  children?: MenuNeto[];
  dataHoraCriacao?: Date | string;
  usuario?: UsuarioList;
  ordem?: number;
  isEscolaLegislativo?: boolean;
}

export const ISmenuFilho: MenuFilho = {
  id: '',
  label: '',
  children: [],
  link: '',
  noticia: ISnoticia,
  menuPai: ISmenuPaiList,
  dataHoraCriacao: '',
  usuario: ISusuarioList,
  ordem: 0,
  isEscolaLegislativo: false
};

export interface MenuFilhoDTO {
  id?: string;
  idPai: string;
  link?: string;
  label: string;
  idNoticia?: string;
  ordem: number;
  isEscolaLegislativo?: boolean;
}
export const ISmenuFilhoDTO: MenuFilhoDTO = {
  id: '',
  idPai: '',
  link: '',
  label: '',
  idNoticia: '',
  ordem: 0,
  isEscolaLegislativo: false
};

export interface MenuFilhoList {
  id: string;
  label: string;
  link: string;
  idNoticia: string;
  ordem?: number;
  menuPai: MenuPaiList;
  dataHoraCriacao?: Date | string;
  usuario: UsuarioList;
  isEscolaLegislativo?: boolean;
}
export const ISmenuFilhoList: MenuFilhoList = {
  id: '',
  label: '',
  link: '',
  ordem: 0,
  idNoticia: '',
  menuPai: ISmenuPaiList,
  dataHoraCriacao: '',
  usuario: ISusuarioList,
  isEscolaLegislativo: false
};
